
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.502.5c.659 0 .962 2.784.962 2.784v2.581s5.202 3.443 5.375 3.582c.173.14.048.933.048.933L9.68 8.88l-1.235-.14v.25h.062l-.001-.015c0-.04.029-.074.069-.081h.605l.063.029a2 2 0 01.096.74c-.023.44-.089.877-.197 1.303h-.106v.145h-.26v-.145h-.072l-.158.611h-.481l-.101.385s1.841 1.384 2.12 1.601c.279.216.111.807.111.807L7.69 13.202v.24a.568.568 0 00-.101 0c.25.049.433.27.433.524a.536.536 0 01-.534.534.536.536 0 01-.534-.534c0-.254.183-.475.433-.524a.568.568 0 00-.101 0v-.24L4.781 14.37s-.168-.586.111-.807c.279-.222 2.12-1.601 2.12-1.601l-.101-.385H6.43l-.158-.611h-.048v.145h-.26v-.149h-.106a6.76 6.76 0 01-.197-1.303 2.002 2.002 0 01.096-.741l.063-.029h.605c.04.007.069.041.069.081l-.001.016h.062v-.25l-1.235.139-4.207 1.5s-.125-.793.048-.933c.173-.139 5.375-3.581 5.375-3.581V3.279S6.844.5 7.502.5z"}})])
          )
        }
      }
    